import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { Patient } from 'src/app/core/models/patient/patient';
import {
  PatientAdvancedDirective,
} from 'src/app/core/models/patient/patientAdvancedDirective';
import { PatientChildren } from 'src/app/core/models/patient/patientChildren';
import { UserService } from 'src/app/core/services/v2/user.service';

import {
  PatientEmergencyContactInfo,
} from '../../../../core/models/patient/patientEmergencyContactInfo';
import { PatientService } from '../../../../core/services/v2/patient.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';
import {
  PatientEmergencyContactEditComponent,
} from '../../profile-edit/patient-emergency-contact-edit/patient-emergency-contact-edit.component';
import {
  SidebarPatientEditComponent,
} from '../../profile-edit/sidebar-patient-edit/sidebar-patient-edit.component';

@Component({
  selector: 'app-profile-emergency-contact-info',
  templateUrl: './profile-emergency-contact-info.component.html',
  styleUrls: ['./profile-emergency-contact-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileEmergencyContactInfoComponent implements OnInit {

  @Input() isParams = false;
  @Input() editEnable:boolean = true;
  @Input() emergencyContactInfos: PatientEmergencyContactInfo[];
  @Output() toggleEditEvent = new EventEmitter();

  // isParams = false;
  // param: number;

  emergencyContact: PatientEmergencyContactInfo;
  sectionName: string;
  toggleSidebar = false;
  private patientInfoDialog: MatDialogRef<TemplateRef<any>>;
  @ViewChild(SidebarPatientEditComponent, { static: false }) childComponent: SidebarPatientEditComponent;
  patientProfile: Patient;
  childrenGuardian: PatientChildren;
  advancedDirective: PatientAdvancedDirective;

  constructor(
    private patientService: PatientService,private userService: UserService,private router: ActivatedRoute,
    private loaderService: WindowLoaderService,public dialog: MatDialog,) { }
  ngOnInit() {
    // this.router.params.subscribe(
    //   (params: any) => {
    //     if (params.id) {
    //       this.isParams = true;
    //       this.param = params.id;
    //     }
    //   },
    //   (error) => { console.error(error); }
    // );


    // this.userService.getUserDetails().subscribe(
    //   (res) => {
    //     // this.user = res;
    //     if (this.isParams) {
    //       this.getPatientDetailsById(this.param);
    //     } else {
    //       this.getPatientDetailsByUserId();
    //     }
    //   },
    //   (error) => { console.error(error); });

  }
  toggleEdit(emergencyContact: PatientEmergencyContactInfo) {
    if (emergencyContact) {
      this.toggleEditEvent.emit(emergencyContact);

    } else {
      this.toggleEditEvent.emit(new PatientEmergencyContactInfo());
    }

  }
  destroyChild() {
    this.childComponent.ngOnDestroy();
  }

  public showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector('body');
    if (isOpen) {
      body.style.cssText = 'height:100vh; overflow:hidden';
    } else {
      body.style.cssText = 'height:auto; overflow:visible';
    }
  }

  togglePopUp(patientProfile: Patient) {
    this.patientProfile = patientProfile;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if(this.toggleSidebar === false){
      this.patientInfoDialog.close();
    }
  }

  // toggleAddEmergency(emergencyContactInfo: PatientEmergencyContactInfo) {
  //   if (emergencyContactInfo) {
  //     this.toggleRowEditEmergency(emergencyContactInfo);

  //   } else {
  //     this.toggleRowEditEmergency(new PatientEmergencyContactInfo());
  //   }
  // }


  public toggleRowEditEmergency(emergencyContactInfo: PatientEmergencyContactInfo) {
    const isEditableModal = emergencyContactInfo.id ? true : false;
    const patientEditDialogRef = this.dialog.open(PatientEmergencyContactEditComponent, {
      panelClass: `${this.sectionName}-dialog--popup`,
      width: '540px',
      disableClose: false,
      data: {
        isEditMode: isEditableModal,
        emergencyContactInfo: emergencyContactInfo,
        sectionName: this.sectionName,
        patientId: emergencyContactInfo.patientId,
      },
    });
    patientEditDialogRef.afterClosed().subscribe(result => {
      this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
        (details) => {
          if (details) {
            this.emergencyContactInfos = details.patientEmergencyContactInfos;
          }
        },
        (error) => { console.error(error); },
        () => {
          this.loaderService.hide();
        }
      );
    });
  }

  closeDialogBox() {
    this.patientInfoDialog.close();
  }

  deleteEmergencyContact(patientId: number, id: number, ind: number) {
    this.loaderService.blockWithLoader(this.patientService.deletePatientEmergencyContactInfo(patientId, id)).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.emergencyContactInfos.splice(ind, 1);
        } else
          console.error(res);
      },
      (error) => { console.error(error); }
    );

  }

}
